var exports = {
  "Qs": "UserVideoTab.module__content___TXpraE",
  "zN": "UserVideoTab.module__controlGroup___TXpraE",
  "ZT": "UserVideoTab.module__deviceNotice___TXpraE",
  "ei": "UserVideoTab.module__deviceNoticeText___TXpraE",
  "dv": "UserVideoTab.module__deviceNoticeTitle___TXpraE",
  "H6": "UserVideoTab.module__deviceNoticeDescription___TXpraE",
  "IR": "UserVideoTab.module__premiumCard___TXpraE",
  "LS": "UserVideoTab.module__premiumHeader___TXpraE",
  "PC": "UserVideoTab.module__premiumIcon___TXpraE",
  "CA": "UserVideoTab.module__premiumTitle___TXpraE",
  "SM": "UserVideoTab.module__premiumDescription___TXpraE",
  "eQ": "UserVideoTab.module__frameRateNote___TXpraE",
  "xe": "UserVideoTab.module__frameRateIcon___TXpraE",
  "hP": "UserVideoTab.module__actionButton___TXpraE",
  "a9": "UserVideoTab.module__cameraControlGroup___TXpraE",
  "$l": "UserVideoTab.module__actionRow___TXpraE",
  "ZJ": "UserVideoTab.module__actionLabel___TXpraE",
};

module.exports = exports;
